import { useEffect } from 'react'

// User management moved to the v2 portal (Settings › Manage Users), which is
// served from the same host under /v2 on every environment. A full page load
// is required: v2 is a separate app, not a route of this one.
export const V2_USERS_PATH = '/v2/users'

const RedirectToV2Users = () => {
  useEffect(() => {
    window.location.replace(V2_USERS_PATH)
  }, [])

  return null
}

export default RedirectToV2Users
